import { useEffect, useState } from 'react'

const useGetWindowSize = () => {
    const [windowSize, setwindowSize] = useState<{ x: number, y: number }>({ x: 1, y: 1 })

    useEffect(() => {
        setwindowSize({ x: window.innerWidth, y: window.innerHeight })
        const setValue = () => {
            setwindowSize({ x: window.innerWidth, y: window.innerHeight })
        }
        window.addEventListener("resize", setValue)

        return () => {
            window.removeEventListener("resize", setValue)
        }
    }, [])
    return {
        windowSize
    }
}

export default useGetWindowSize